import PageHeaders from "@app/sharedComponents/CommonHeader/CommonHeader";
import { Image, Platform } from "react-native";
import { useAppSelector } from "@app/store/hooks";
import { Theme, themeColorSet, ThemedPressable, ThemedText, ThemedView } from "@app/theme";
import { formatIndianCurrency } from "@app/utils/utility";
import dayjs from "dayjs";
import { ScrollView } from "react-native";
import Button from "@app/sharedComponents/Button/Button";
import ROUTE from "@app/navigationApp/routes";
import CalendarArrow from "../../../assets/Icons/CalendarArrow";
import Calendar from "../../../assets/Icons/SYSTEM_CALENDAR_DLS";
import { useState } from "react";
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet";
import ConfirmManualPay from "./component/ConfirmManualPay";
import UserPayConfirmation from "./component/UserPayConfirmation";
import { REPAYMENT_COLLECTION_TYPE } from "@app/utils";
import { Warning,Info } from '@app/sharedComponents/Icons/Icons';
import InterestBreakUp from "./component/InterestBreakUp";
import Rupee from "../../../assets/Icons/Rupee";
import { LENDER_ID } from "@app/types/regix";
import SellOfNote from "./component/SellOfNote";
import { useTheme } from "@shopify/restyle";

const InterestPayment = ({navigation,route})=>{
    const interestDetails = useAppSelector((state) => state.auth.interestDetails);
    const {totalAmount,interestStatus,autoPayDate,isMandateSetup,month,year,outstandingInterest,sellOffDate} = interestDetails
    const creditDetails = useAppSelector((state) => state.auth.creditDetails);
    const {accountNumber,bankName,bankCode} = useAppSelector((state) => state.auth.userProfile?.bankDetails);
    const [isBottomSheetVisible, setIsBottomSheetVisible] = useState(false);
    const [bottomSheetType, setBottomSheetType] = useState(null);
    const hardBreachDate = sellOffDate ? new Date(sellOffDate).getDate():  15//
    const firebaseParams = useAppSelector((state) => state.firebaseParams);
    const currentDate = firebaseParams?.follow_firebase_date==="true" ? dayjs(firebaseParams?.current_volt_date): dayjs()
    const currentMonth = currentDate.format('MMM'); // get current month name like Jan or feb etc
    const currentYear = currentDate.format('YY'); // get current year like 25 or 24 etc
    const softBreachDate = new Date(autoPayDate).getDate(); // autodebit date is assumed to be soft breach date
    const isHardDateBreached = Number(currentDate.format('DD')) >= hardBreachDate;
    const isFromTata = LENDER_ID?.TATA?.toLowerCase() === creditDetails?.lendingPartnerId?.toLowerCase();
    const isLenderBajaj = LENDER_ID?.BAJAJ?.toLowerCase() === creditDetails?.lendingPartnerId?.toLowerCase();
    const {colors} = useTheme<Theme>();
    const interestMsg = ()=>{
    
        if(interestStatus === "DUE"){
          if(isMandateSetup){
            // msg Auto-debit on {softBreachDate} {currentMonth}, {currentYear} from HDFC XXXX 7029
            return (
            <ThemedText variant='b4r' color='text-primary' ml="sm" flexShrink={1}>
              Ensure balance of
              <ThemedText variant='b4b' color='text-primary'> ₹{formatIndianCurrency(totalAmount)} </ThemedText>
              in your bank account to avoid penalty charges</ThemedText>
          )
          }else{
            // msg Pay by {softBreachDate}-{currentMonth} to avoid penalty charges
            return(
            <ThemedView flexDirection='row' alignItems='center' flex={1} flexWrap='wrap' ml="sm">
              <ThemedText variant='b4r' color='text-primary'>
                Pay by{' '}   
                <ThemedText variant='b4b' color='text-primary'>
                  {softBreachDate}-{currentMonth} 
                </ThemedText>
              {' '}to avoid penalty charges.
              </ThemedText>
            <ThemedText variant='b4b' color='text-action-primary' ml="2xs" onPress={()=>navigation.navigate(ROUTE.INTEREST_LEARN_MORE,{outstandingInterest:totalAmount,isFromTata})}>
              Learn more
            </ThemedText>
            </ThemedView>
            )
    
          }
        } else if(interestStatus === "AWAITING_MANDATE_STATUS" && isMandateSetup){
          // msg Processing auto-debit! Need help? Learn more
          return (
            <ThemedView flexDirection='row' alignItems='center' flex={1} flexWrap='wrap'  ml="sm" flexShrink={1}>
            <ThemedText variant='b4b' color='text-primary'>We are processing auto-debit.
              <ThemedText variant='b4r' color='text-primary'> It may take up to 2 business days. Need help? </ThemedText>
                <ThemedText variant='b4b' color='text-action-primary' onPress={()=>navigation.navigate(ROUTE.CONTACT_US)}>
                Contact us
                </ThemedText>
            </ThemedText>
            </ThemedView>
          )
        } else if(interestStatus === "OVERDUE"){
          // msg Last auto-debit failed! Pay before {hardBreachDate} {currentMonth}, {currentYear} to avoid defaulting.
          if(isHardDateBreached){
           return( <ThemedView flexDirection='row' alignItems='center' flex={1} flexWrap='wrap' ml="sm">
            <ThemedText variant='b4r' color='text-primary'>Your interest is still overdue. Need help?</ThemedText>
              <ThemedText variant='b4b' color='text-action-primary' onPress={()=>navigation.navigate(ROUTE.CONTACT_US)}>
                {' '}Contact support
              </ThemedText>
            </ThemedView>)
          }
          else if(isMandateSetup){
            return(
            <ThemedView flexDirection='row' alignItems='center' flex={1} flexWrap='wrap' ml="sm">
              <ThemedText variant='b4b' color='text-primary'>Last auto-debit failed! </ThemedText>
              <ThemedText variant='b4r' color='text-primary'>Pay by<ThemedText variant='b4b' color='text-primary'> {hardBreachDate}-{currentMonth}</ThemedText> to avoid defaulting. </ThemedText>
                <ThemedText variant='b4b' color='text-action-primary' onPress={()=>navigation.navigate(ROUTE.INTEREST_LEARN_MORE,{outstandingInterest:totalAmount,isFromTata})}>
                  Learn more
                </ThemedText>
            </ThemedView>
            )
          } 
          else if(!isMandateSetup && !isHardDateBreached){
            return(
            <ThemedView flexDirection='row' alignItems='center' flex={1} flexWrap='wrap' ml="sm">
              <ThemedText variant='b4r' color='text-primary'>Pay by <ThemedText variant='b4b' color='text-primary'>{hardBreachDate}-{currentMonth}</ThemedText> to avoid defaulting.</ThemedText>
                <ThemedText variant='b4b' color='text-action-primary'  ml="2xs" onPress={()=>navigation.navigate(ROUTE.INTEREST_LEARN_MORE,{outstandingInterest:totalAmount,isFromTata})}>
                  Learn more
                </ThemedText>
            </ThemedView>
            )
          }else{
            // msg Your interest is still overdue. Need help? Contact support
            return(
            <ThemedView flexDirection='row' alignItems='center' flex={1} flexWrap='wrap' ml="sm">
            <ThemedText variant='b4r' color='text-primary'>Your interest is still overdue. Need help?</ThemedText>
             <ThemedText variant='b4b' color='text-action-primary' onPress={()=>navigation.navigate(ROUTE.CONTACT_US)}>
                {' '}Contact support
              </ThemedText>
            </ThemedView>
            )
          }
        } else{
          return null
        }
      }

    const continuePayment = () =>{
        closeBottomSheet();
        setTimeout(()=>{
          navigateToPayments()
        },600)
    }
    const navigateToPayments = () =>{
      navigation.navigate(ROUTE.CONFIRM_PAYMENT_DETAILS,{selectedAmount:totalAmount,paymentType:REPAYMENT_COLLECTION_TYPE.IN_APP_INTEREST_COLLECTION});
    }

    const openBottomSheet = (type:string) =>{
      if(isBottomSheetVisible){
        return
      }
        setBottomSheetType(type)
        setIsBottomSheetVisible(true);
    }

    const closeBottomSheet = () =>{
      if(isBottomSheetVisible){
        setIsBottomSheetVisible(false);
        setTimeout(()=>{
            setBottomSheetType(null)
        },600)
      }
    }


    return(
        <>
        <PageHeaders pageName={route?.name} label="Interest payment" navigation={navigation}/>
        <ScrollView style={{flex:1, backgroundColor:themeColorSet["bg-surface-primary"], padding:16}}>
        <ThemedView flexDirection="row" alignItems="center">
        <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
            <Rupee size={40} color={colors['icon-action-primary']}/>
        </ThemedView>
            <ThemedView ml="sm">
            <ThemedText variant="b4r" color="text-secondary">{interestStatus === "OVERDUE" ? 'Amount overdue' :  'Amount due'}</ThemedText>
                <ThemedView flexDirection="row" alignItems="center">
                <ThemedText variant="b3m" color="text-primary">₹{formatIndianCurrency(totalAmount)}</ThemedText>
                <ThemedPressable ml="xs" {... Platform.OS!=='web' && {mt:"xs"}} onPress={()=>{openBottomSheet("INTEREST_BREAKUP")}}>
                    <Info size={16} color={colors['icon-secondary']}/>
                </ThemedPressable>
                </ThemedView>
            </ThemedView>
        </ThemedView>
        <ThemedView height={1} backgroundColor="border-primary" width={"100%"} my="lg"/>
        <ThemedView flexDirection="row" alignItems="center">
            <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
            <Calendar size={24} color={themeColorSet["bg-action-primary"]} />
            </ThemedView>
            <ThemedView  ml="sm">
                <ThemedText variant="b4r" color="text-secondary">Month</ThemedText>
                <ThemedText variant="b3m" color="text-primary">{month}, {dayjs(year).format('YYYY')}</ThemedText>
            </ThemedView>
        </ThemedView>
        <ThemedView height={1} backgroundColor="border-primary" width={"100%"} my="lg"/>
        <ThemedView flexDirection="row" alignItems="center">
            <ThemedView backgroundColor="bg-fill-emphasis-primary-1" width={40} height={40} borderRadius="full" justifyContent="center" alignItems="center">
            <CalendarArrow size={24} color={colors['icon-action-primary']}/>
            </ThemedView>
            <ThemedView ml="sm">
                <ThemedText variant="b4r" color="text-secondary">{isMandateSetup?'Auto-debit date':'Due date'}</ThemedText>
                <ThemedText variant="b3m" color="text-primary">{dayjs(autoPayDate).format('DD MMM, YYYY')}</ThemedText>
            </ThemedView>
        </ThemedView>
        {isMandateSetup ?
        <ThemedView borderWidth={1} borderColor="border-primary" borderRadius="lg" my="lg">
            <ThemedView p="lg"  flexDirection="row" justifyContent="space-between">
                <ThemedView>
                    <ThemedText variant='b3r' color='text-secondary' >
                        {bankName}
                    </ThemedText>
                    <ThemedText variant='b3s' color='text-primary' >
                        xxxx {accountNumber.toString().slice(-4)}
                    </ThemedText>
                </ThemedView>
            <Image
                source={{uri:`https://volt-images.s3.ap-south-1.amazonaws.com/bank-logos/pngs/${bankCode??'default'}.png`}}
                style={{width: 40, height: 40}}
            />
            </ThemedView>
            <ThemedView height={1} backgroundColor="border-primary" width={'100%'} />
            <ThemedView flexDirection='row'  backgroundColor={interestStatus === "OVERDUE" ?'bg-fill-error' :'bg-fill-warning'} px='lg' py='sm' borderBottomRightRadius='lg' borderBottomLeftRadius='lg'>
          {interestStatus === "OVERDUE"? <Info size={20} weight="fill" color={colors['icon-warning']}/>:<Info size={20} weight="fill"  color={colors['icon-warning']}/>}
          {interestMsg()}
        </ThemedView>
        </ThemedView> :  
        <ThemedView borderWidth={1} borderColor="border-primary" borderRadius="lg" my="lg">
            <ThemedView flexDirection='row'  backgroundColor={interestStatus === "OVERDUE" ?'bg-fill-error' :'bg-fill-warning'} px='lg' py='lg' borderRadius='lg' >
          {interestStatus === "OVERDUE"? <Info size={20} weight="fill" color={colors['icon-warning']}/>:<Info size={20} weight="fill"  color={colors['icon-warning']}/>}
          {interestMsg()}
        </ThemedView>
        </ThemedView>}
        </ScrollView>
        <ThemedView p="lg" alignItems="center" backgroundColor="bg-fill-primary" borderTopColor="border-primary" borderTopWidth={1} >
          {(interestStatus === "OVERDUE" || (interestStatus === "DUE" && !isMandateSetup)) && <Button label="Continue" type="SOLID" handlePress={()=>{ isMandateSetup && interestStatus === "OVERDUE" &&isHardDateBreached ? openBottomSheet("SELL_OFF_NOTE") :navigateToPayments()}} />}
        {(interestStatus === "AWAITING_MANDATE_STATUS"  ) && isMandateSetup &&
        <>
            <ThemedText variant='b4r' color='text-secondary' >
                Is your amount debited?
            </ThemedText>
            <Button label="Yes" type="SOLID" handlePress={()=>openBottomSheet("USER_CONFIRMATION")} overRideStyle={{marginVertical:16}} />
            <Button label="No" type="OUTLINED" handlePress={()=>openBottomSheet("CONFIRM_MANUAL_PAY")}/>
        </>
          }
          {interestStatus === "DUE" && isMandateSetup &&
        <>
            <ThemedText variant='b4r' color='text-secondary' >
                    Is bank account inactive or mandate not 
            </ThemedText>
            <ThemedView flexDirection="row" alignItems="center" >
                <ThemedText variant='b4r' color='text-secondary' >
                    registered? 
                </ThemedText>
                <ThemedPressable onPress={()=>openBottomSheet("CONFIRM_MANUAL_PAY")} >
                    <ThemedText variant='b4s' color='text-action-primary' ml="xs">
                       Pay now
                    </ThemedText>
                </ThemedPressable>
            </ThemedView>
          <Button label="Ok, got it!" type="SOLID" handlePress={()=>navigation.navigate(ROUTE.HOME)} overRideStyle={{marginVertical:16}} />
        </>
        // <Button label="Continue" type="SOLID" handlePress={continuePayment} overRideStyle={{marginVertical:16}} />
        }
        </ThemedView>
        <BottomSheetContainer
            isVisible={isBottomSheetVisible}
            close={closeBottomSheet}
            closeOnBackdropPress={true}
            borderTopRightRadius={10}
            borderTopLeftRadius={10}
        >
            {bottomSheetType === "INTEREST_BREAKUP" &&  <InterestBreakUp closeBottomSheet={closeBottomSheet} interestDetails={interestDetails}/>}
            {bottomSheetType === "USER_CONFIRMATION" &&  <UserPayConfirmation closeBottomSheet={closeBottomSheet}/>}
            {bottomSheetType === "CONFIRM_MANUAL_PAY" &&  <ConfirmManualPay interestStatus={interestStatus} continuePayment={continuePayment}/>}
            {bottomSheetType === "SELL_OFF_NOTE" &&  <SellOfNote  continuePayment={continuePayment}/>}
        </BottomSheetContainer>
        </>
    )
}

export default InterestPayment;